import { ubemIoApi } from 'src/redux/services/ubem'
import analysisReducer from 'src/redux/slices/analysis/reducers'
import asyncTasksReducer from 'src/redux/slices/async-processing/reducers'
import completionReducer from 'src/redux/slices/completion/reducers'
import errorReducer from 'src/redux/slices/error/reducers'
import navigationReducer from 'src/redux/slices/navigation/reducers'
import projectReducer from 'src/redux/slices/project/reducers'
import umibuilderReducer from 'src/redux/slices/umibuilder/reducers'
import upgradesReducer from 'src/redux/slices/upgrades/reducers'
import userReducer from 'src/redux/slices/user/reducers'

import { configureStore } from '@reduxjs/toolkit'
import { setupListeners } from '@reduxjs/toolkit/query/react'

export const store = configureStore({
  reducer: {
    [ubemIoApi.reducerPath]: ubemIoApi.reducer,
    user: userReducer,
    asyncTasks: asyncTasksReducer,
    completion: completionReducer,
    error: errorReducer,
    navigation: navigationReducer,
    analysis: analysisReducer,
    umibuilder: umibuilderReducer,
    upgrades: upgradesReducer,
    project: projectReducer,
  },
  // Adding the api middleware enables caching, invalidation, polling,
  // and other useful features of `rtk-query`.
  middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat(ubemIoApi.middleware),
})

// optional, but required for refetchOnFocus/refetchOnReconnect behaviors
// see `setupListeners` docs - takes an optional callback as the 2nd arg for customization
setupListeners(store.dispatch)

export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch
